import type {
  ComponentLocalizationMap,
  LocalizationDerivationRegistry,
} from '@packages/domains/localization/dom/model';
import {QualifiedMap} from '@packages/systems/wfdl-Qualified';

export type DomLocalizationStagedState = {
  componentLocalizations: ComponentLocalizationMap;
  derivedKeys: LocalizationDerivationRegistry;
};

export type DomLocalizationState = {
  enableExternalizedBindings: boolean;
  componentLocalizations: ComponentLocalizationMap;
  staged: DomLocalizationStagedState | null;
  derivedKeys: LocalizationDerivationRegistry;
};

export const defaultDomLocalizationState: DomLocalizationState = {
  enableExternalizedBindings: false,
  componentLocalizations: QualifiedMap.empty(),
  staged: null,
  derivedKeys: QualifiedMap.empty(),
};
